import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay, EffectFade } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';
import { motion } from 'framer-motion';

import { hotelAssets } from '../assets/hotelAssets';
import { HOTEL_NAME } from '../config/hotel';

const slides = [
  {
    title: `Welcome to ${HOTEL_NAME}`,
    subtitle: 'Reception & Hospitality',
    leftImg: hotelAssets.heroSlides.reception.leftImg,
    rightImgs: hotelAssets.heroSlides.reception.rightImgs,
  },
 
  {
    title: 'Relax in Comfort',
    subtitle: 'Room Categories',
    leftImg: hotelAssets.heroSlides.rooms.leftImg,
    rightImgs: hotelAssets.heroSlides.rooms.rightImgs,
  },
];

const HeroSlider = () => {
  return (
    <div id='home' className='flex justify-center items-center py-8' style={{ background: '#FFFFE7' }}>
      <div className='w-full max-w-7xl rounded-3xl shadow-2xl bg-white/80 p-6 lg:p-10'>
        <Swiper
          modules={[Navigation, Autoplay, EffectFade]}
          navigation
          loop={true}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          effect="fade"
          fadeEffect={{
            crossFade: true
          }}
          speed={1000}
          className='heroSlider w-full h-[600px] lg:h-[750px] rounded-3xl'
        >
          {slides.map((slide, index) => (
            <SwiperSlide key={index} className='flex flex-col lg:flex-row h-full'>
              {/* Left: Main image with overlaid text */}
              <div className='w-full lg:w-1/2 h-full flex items-center justify-center lg:pr-4 relative group'>
                <motion.img
                  src={slide.leftImg}
                  alt={slide.title}
                  className='object-cover w-full h-full rounded-2xl shadow-lg border-4 border-white'
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 1 }}
                />

                <motion.div
                  className='absolute inset-0 z-[1] bg-gradient-to-t from-black/60 to-transparent rounded-2xl pointer-events-none'
                  aria-hidden='true'
                />

                <div className='absolute inset-0 z-10 flex flex-col items-center justify-end pb-8 lg:pb-12 pointer-events-none'>
                  <motion.div
                    initial={{ y: 20, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ delay: 0.3, duration: 0.8 }}
                    className='uppercase font-tertiary tracking-[4px] text-white text-sm lg:text-lg mb-2 bg-black/60 px-4 py-1 rounded-full'
                  >
                    {slide.subtitle}
                  </motion.div>
                  <motion.h1
                    initial={{ y: 30, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ delay: 0.5, duration: 0.8 }}
                    className='text-xl lg:text-4xl xl:text-5xl font-primary uppercase tracking-[2px] leading-tight text-white font-bold text-center px-6 py-2 max-w-md lg:max-w-xl'
                  >
                    {slide.title}
                  </motion.h1>
                </div>
              </div>

              {/* Right: 2 images on top, 1 wide image below */}
              <div className='w-full lg:w-1/2 h-full flex flex-col gap-4 lg:pl-4 mt-4 lg:mt-0'>
                <motion.div 
                  className='flex gap-4 h-1/2'
                  initial={{ opacity: 0, x: 20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 0.7, duration: 0.8 }}
                >
                  <div className='w-1/2 h-full overflow-hidden rounded-xl shadow-md border-2 border-white group'>
                    <img 
                      src={slide.rightImgs[0]} 
                      alt='' 
                      className='object-cover w-full h-full transition-transform duration-700 group-hover:scale-110'
                    />
                  </div>
                  <div className='w-1/2 h-full overflow-hidden rounded-xl shadow-md border-2 border-white group'>
                    <img 
                      src={slide.rightImgs[1]} 
                      alt='' 
                      className='object-cover w-full h-full transition-transform duration-700 group-hover:scale-110'
                    />
                  </div>
                </motion.div>
                
                <motion.div 
                  className='h-1/2'
                  initial={{ opacity: 0, x: 20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 0.9, duration: 0.8 }}
                >
                  <div className='w-full h-full overflow-hidden rounded-xl shadow-md border-2 border-white group'>
                    <img 
                      src={slide.rightImgs[2]} 
                      alt='' 
                      className='object-cover w-full h-full transition-transform duration-700 group-hover:scale-110'
                    />
                  </div>
                </motion.div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default HeroSlider;
